import React from 'react';
import PassageTextFeedback from '../../utils/feedback/passageTextFeedback';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    const {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        answerCount,
        rightFeedbackProps,
        leftFeedbackProps,
    }
}

const ClozePassageIncorrectFeedback = ({
    answerCount,
    rightFeedbackProps: {
        textCorrectAnswer,
        
        userAnswer,
        passage,
        defaultFeedback,
        score,
    },
    leftFeedbackProps: {
        question,
        qtype,
        correctAnswer,
        selectedAnswer,
    },
}) => {
    return (
        <span>
          <h4 class="text-danger">That's incorrect</h4>          
          <div class="quiz-area-answer">
             <div class="display-flex align-center">
                <div class="bord-right col-md-3">
                   <h4 class="text-danger text-right">Your answer</h4>
                </div>
        				<PassageTextFeedback passage={passage}  correctAnswer={correctAnswer[0].split('#')} selectedAnswer={selectedAnswer}/> 
        		 </div>
             <div class="display-flex align-center">
                <div class="bord-right col-md-3">
                   <h4 class="text-success text-right">Correct answer</h4>
                </div>	
                <div>
                   <p class="pad-all mar-no">
                    <PassageTextFeedback passage={passage}  correctAnswer={correctAnswer[0].split('#')} selectedAnswer={correctAnswer[0].split('#')}/> 
                   </p>
                </div>
             </div>
          </div>
			  </span>
    )
}

export default connect(mapStateToProps)(ClozePassageIncorrectFeedback);